import { styled } from '@mui/material';
import React, { ReactNode } from 'react';

const Container = styled('div')({
  display: 'flex',
  position: 'absolute',
  height: '100%',
  width: '100%',
  background:
    'linear-gradient(90deg, hsla(348, 44%, 32%, 1) 0%, hsla(347, 29%, 46%, 1) 52%, hsla(348, 57%, 30%, 1) 100%)',
});

const ContentWrapper = styled('div')({
  width: '100%',
  transitionDuration: '225ms',
  paddingLeft: 0,
  overflowY: 'auto',
  position: 'relative',
  paddingTop: 0,
});

const Content = styled('div')({
  minHeight: 'calc(100vh)',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Container>
      <ContentWrapper id="content-wrapper">
        <Content id="app-content">{children}</Content>
      </ContentWrapper>
    </Container>
  );
};

export default AuthLayout;
